import React from 'react';

import { generateClient } from 'aws-amplify/api';

import { ChatMessageItem } from '../../graphql/API';
import { onMessageUpdated } from '../../graphql/subscriptions';
import { GqlError, getError, getErrorFromResult, processGqlResult } from '../../utils/gql-utils';

const client = generateClient();

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useMessageSeenListenerQuery = ({ conversationId }: { conversationId: string }) => {
  const [updatedMessage, setUpdatedMessage] = React.useState<Nullable<ChatMessageItem>>(null);
  const [error, setErorr] = React.useState<GqlError>();

  React.useEffect(() => {
    const createSub = client.graphql({
      query: onMessageUpdated,
      variables: { conversationId },
    }).subscribe({
      next: ({ data }: { data: { onMessageUpdated: ChatMessageItem } }) => {
        const _message = processGqlResult<ChatMessageItem>('onMessageUpdated', { data });
        setUpdatedMessage(_message);

        const errorFromResponse = getErrorFromResult({ data });
        if (errorFromResponse) {
          throw errorFromResponse;
        }
      },
      error: (ex) => {
        const raisedError = getError(ex);
        console.error(raisedError);
        setErorr(raisedError);
      },
    });

    return () => {
      createSub.unsubscribe();
    };
  }, [conversationId, setUpdatedMessage]);

  return {
    updatedMessage,
    error,
  };
};
